import { Button } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { T } from '../../../Translations';
import { SsoConfigurationsResource } from '../Types';
import BeforeYouBegin from './BeforeYouBegin';
import ConnectionList from './ConnectionList';
import GetStarted from './GetStarted';
import LoginDomains from './LoginDomains';

interface Props {
  resource: SsoConfigurationsResource;
}

const Hub: React.FC<Props> = ({ resource }) => {
  const navigate = useNavigate();
  const { connections } = resource.payload;

  return connections.length === 0 ? (
    <>
      <h2 className="text-2xl font-semibold text-foreground">
        <T kind="Single Sign-On" />
      </h2>
      <p className="mt-1 max-w-3xl text-muted-foreground">
        <T kind="Let your team sign in with your company credentials. Add one or more identity providers, then choose which of your login domains use each one." />
      </p>
      <div className="mt-8 grid grid-cols-1 items-start gap-6 lg:grid-cols-5">
        <div className="lg:col-span-3">
          <GetStarted />
        </div>
        <div className="flex flex-col gap-6 lg:col-span-2">
          <BeforeYouBegin />
          <LoginDomains resource={resource} />
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h2 className="text-2xl font-semibold text-foreground">
            <T kind="Single Sign-On" />
          </h2>
          <p className="mt-1 max-w-3xl text-muted-foreground">
            <T kind="Each login domain chooses one sign-in method: an identity provider connection, or password sign-in." />
          </p>
        </div>
        <Button
          color="primary"
          onClick={() => navigate('/single_sign_on/add')}
          data-intercom-target="sso-add-identity-provider-button"
        >
          <T kind="Add identity provider" />
        </Button>
      </div>
      <div className="mt-8 grid grid-cols-1 items-start gap-6 lg:grid-cols-2">
        <ConnectionList connections={connections} />
        <LoginDomains resource={resource} />
      </div>
    </>
  );
};

export default observer(Hub);
